import { render, staticRenderFns } from "./PointsPagoForm.vue?vue&type=template&id=b578a93e&"
import script from "./PointsPagoForm.vue?vue&type=script&lang=js&"
export * from "./PointsPagoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports